// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1787d","comment":"styles_comment__2Tfd9"};